var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model.number",
          value: _vm.curFrame,
          expression: "curFrame",
          modifiers: { number: true }
        }
      ],
      attrs: { type: "range", min: "0", max: "2500" },
      domProps: { value: _vm.curFrame },
      on: {
        __r: function($event) {
          _vm.curFrame = _vm._n($event.target.value)
        },
        blur: function($event) {
          return _vm.$forceUpdate()
        }
      }
    }),
    _vm._v("Keyframe = " + _vm._s(_vm.curFrame)),
    _c("br"),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model.number",
          value: _vm.index,
          expression: "index",
          modifiers: { number: true }
        }
      ],
      attrs: { type: "radio", id: "matrix", value: "1" },
      domProps: { checked: _vm._q(_vm.index, _vm._n("1")) },
      on: {
        change: function($event) {
          _vm.index = _vm._n("1")
        }
      }
    }),
    _vm._v("Enter The Matrix"),
    _c("br"),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model.number",
          value: _vm.index,
          expression: "index",
          modifiers: { number: true }
        }
      ],
      attrs: { type: "radio", id: "lime", value: "2" },
      domProps: { checked: _vm._q(_vm.index, _vm._n("2")) },
      on: {
        change: function($event) {
          _vm.index = _vm._n("2")
        }
      }
    }),
    _vm._v("Lime Gram"),
    _c("br"),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model.number",
          value: _vm.index,
          expression: "index",
          modifiers: { number: true }
        }
      ],
      attrs: { type: "radio", id: "under", value: "3" },
      domProps: { checked: _vm._q(_vm.index, _vm._n("3")) },
      on: {
        change: function($event) {
          _vm.index = _vm._n("3")
        }
      }
    }),
    _vm._v("Underwater"),
    _c("br"),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model.number",
          value: _vm.index,
          expression: "index",
          modifiers: { number: true }
        }
      ],
      attrs: { type: "radio", id: "shadow", value: "4" },
      domProps: { checked: _vm._q(_vm.index, _vm._n("4")) },
      on: {
        change: function($event) {
          _vm.index = _vm._n("4")
        }
      }
    }),
    _vm._v("Drop Shadow"),
    _c("br"),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model.number",
          value: _vm.index,
          expression: "index",
          modifiers: { number: true }
        }
      ],
      attrs: { type: "radio", id: "peach", value: "5" },
      domProps: { checked: _vm._q(_vm.index, _vm._n("5")) },
      on: {
        change: function($event) {
          _vm.index = _vm._n("5")
        }
      }
    }),
    _vm._v("Peach Gram"),
    _c("br"),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model.number",
          value: _vm.index,
          expression: "index",
          modifiers: { number: true }
        }
      ],
      attrs: { type: "radio", id: "nofilter", value: "0" },
      domProps: { checked: _vm._q(_vm.index, _vm._n("0")) },
      on: {
        change: function($event) {
          _vm.index = _vm._n("0")
        }
      }
    }),
    _vm._v("None"),
    _c("br"),
    _c(
      "svg",
      { attrs: { viewBox: "0 0 1380 2000" } },
      [
        _c("ocean-scene", {
          attrs: {
            width: 300,
            height: 500,
            "show-viewbox": true,
            align: "topleft",
            filter: _vm.useFilter,
            keyframe: _vm.curFrame
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }